module.exports = __webpack_public_path__ + "images/sprites/ui/icon_tag_5446a2dd068a2e7448e0ad40bbf374df.png";